import React, { Component, ErrorInfo, ReactNode } from 'react';

import { WithTranslation, withTranslation } from 'react-i18next';

interface IProps extends WithTranslation {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<IProps, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return <h1>{this.props.t('somethingWentWrong')}</h1>;
    }

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
